import {createSlice} from "@reduxjs/toolkit";

const initialGuiJjtuScholarsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guiJjtuScholarForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const guiJjtuScholarsSlice = createSlice({
  name: "guiJjtuScholars",
  initialState: initialGuiJjtuScholarsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuiJjtuScholarById
    guiJjtuScholarFetched: (state, action) => {
      state.actionsLoading = false;
      state.guiJjtuScholarForEdit = action.payload.guiJjtuScholarForEdit;
      state.error = null;
    },
    // findGuiJjtuScholars
    guiJjtuScholarsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuiJjtuScholar
    guiJjtuScholarCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guiJjtuScholar);
    },
    // updateGuiJjtuScholar
    guiJjtuScholarUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiJjtuScholarId === action.payload.guiJjtuScholar.guiJjtuScholarId) {
          return action.payload.guiJjtuScholar;
        }
        return entity;
      });
    },
    // deleteGuiJjtuScholar
    guiJjtuScholarDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiJjtuScholarId !== action.payload.guiJjtuScholarId);
    },
    // deleteGuiJjtuScholars
    guiJjtuScholarsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiJjtuScholarId)
      );
    },
  }
});
